module.exports = __webpack_public_path__ + "static/media/workPvcCeilings9.2bf9df80.jpg";